import { DEFAULT_LANG, LANGUAGES } from '../conf/languages';
import { LOCALSTORAGE_LANGUAGE } from '../conf/user';

export interface Lang {
    code: string;
    name: string;
}

export const langFromLanguage = (): Lang => {
    // eslint-disable-next-line max-len
    let codeLang: Lang = DEFAULT_LANG;
    const prevLang = localStorage != null && localStorage.getItem(LOCALSTORAGE_LANGUAGE) ? localStorage.getItem(LOCALSTORAGE_LANGUAGE) : DEFAULT_LANG.code;
    if (prevLang) {
        const cLang = langFromCode(prevLang);
        if (cLang) {
            codeLang = cLang;
        }
    }
    else {
        const browserLangCode = navigator.language;
        const browserLang = langFromCode(browserLangCode);
        if (browserLang) {
            codeLang = browserLang;
        }
    }
    return codeLang;
};

export const langFromCode = (code: string): Lang | undefined => LANGUAGES.find((lang) => lang.code === code);

